import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import {
  changeChoosenAccounts,
  changeChoosenSources,
  changeChoosenCampaigns,
  addFormData,
} from '../../../features/createBudget/createBudgetSlice';
import { notyfError } from '../../../helpers/notyf';
import { CREATE_BUDGET_AT_CLIENT_STEP_PATH } from '../../../contants';
import api from '../../../config/api';

export const useBudget = () => {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { formData, isUpdateBudget } = useSelector(state => state.createBudget);

  const [isLoading, setIsLoading] = useState(false);
  const [accountIds, setAccountIds] = useState([]);

  useEffect(() => {
    const fetchBudgetData = async () => {
      if (params.id && !isNaN(params.id)) {
        setIsLoading(true);

        try {
          const data = await api.GET_BUDGET(params.id);

          let dataToSet = {
            ...formData,
            id: +data.id,
            amount: +data.amount,
            name: data.name,
            google_budget: data.google_budget,
            type: data.type,
            client: { value: data.client.id, label: data.client.name },
            renew_type: data.renew_type,
          };

          const accounts = data?.campaigns.map(campaign => campaign?.account);
          const uniqueAccounts = accounts?.filter(
            (account, index, self) =>
              index ===
              self.findIndex(_account => _account?.id === account?.id),
          );

          if (uniqueAccounts.length === 1) {
            dispatch(changeChoosenAccounts(uniqueAccounts));
            dispatch(changeChoosenSources([uniqueAccounts[0]?.source]));
          }

          setAccountIds(uniqueAccounts.map(account => account?.id));

          if (!isUpdateBudget) {
            dispatch(addFormData({ ...dataToSet }));
          }
          dispatch(changeChoosenCampaigns(data.campaigns));
        } catch (err) {
          const { response } = err;
          if (response?.status === 404) {
            notyfError("Budget isn't existed");
            navigate(CREATE_BUDGET_AT_CLIENT_STEP_PATH, { replace: true });
          }
        } finally {
          setIsLoading(false);
        }
      }
    };

    fetchBudgetData();
  }, [params.id, isUpdateBudget, dispatch, navigate]);

  return {
    isLoading,
    accountIds,
  };
};
